var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8925 32.8627H25.5004C29.5004 32.8627 32.7435 29.6195 32.7435 25.6195V15.0117C32.7435 11.0117 29.5004 7.76855 25.5004 7.76855H14.8925C10.8925 7.76855 7.64941 11.0117 7.64941 15.0117V25.6195C7.64941 29.6195 10.8925 32.8627 14.8925 32.8627ZM9.95922 14.945C9.95922 12.2901 12.1122 10.1372 14.7671 10.1372H25.6259C28.2808 10.1372 30.4337 12.2901 30.4337 14.945V25.8038C30.4337 28.4587 28.2808 30.6117 25.6259 30.6117H14.7671C12.1122 30.6117 9.95922 28.4587 9.95922 25.8038V14.945Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 26.8873C23.7963 26.8873 26.714 23.9736 26.714 20.3736C26.714 16.7736 23.8002 13.8599 20.2002 13.8599C16.6002 13.8599 13.6865 16.7736 13.6865 20.3736C13.6865 23.9736 16.6002 26.8873 20.2002 26.8873ZM20.2002 16.154C22.5336 16.154 24.4199 18.0442 24.4199 20.3736C24.4199 22.703 22.5297 24.5932 20.2002 24.5932C17.8708 24.5932 15.9806 22.703 15.9806 20.3736C15.9806 18.0442 17.8708 16.154 20.2002 16.154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9296 15.1339C27.7688 15.1339 28.4473 14.4555 28.4473 13.6163C28.4473 12.7771 27.7688 12.0986 26.9296 12.0986C26.0904 12.0986 25.412 12.7771 25.412 13.6163C25.412 14.4555 26.0904 15.1339 26.9296 15.1339Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 0.314453V40.3144H40.1992V0.314453H0.199219ZM39.4149 39.5301H0.983532V1.09877H39.4149V39.5301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInsta);
export default __webpack_public_path__ + "static/media/social_insta.85838c1e058699a43a7f6a5d3a8b7afe.svg";
export { ForwardRef as ReactComponent };